import {configureStore, ThunkAction, Action} from "@reduxjs/toolkit"
import userReducer from "../features/user/userSlice"
import todoReducer from "../features/todo/todoSlice"

export const store = configureStore({
    reducer: {
        user: userReducer,
        todo: todoReducer
    },
})

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
